var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePerfectScrollbar',{ref:"scrollbar",staticClass:"ui-scrollbar-box",attrs:{"settings":_vm.innerSettings}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }